export default __webpack_public_path__ + "images/TC.38c8607.png";